import React, { useEffect } from 'react';
import {
  ApiOutlined,
  HomeOutlined,
  DollarOutlined,
  BugOutlined,
} from '@ant-design/icons';

import {
  Layout, 
  Menu, 
} from 'antd';

import {Outlet, useNavigate, useLocation} from 'react-router-dom'
import { PW } from './config';


const { Content, Sider } = Layout;


const items: SubMenu[] = [
  {
    icon: <HomeOutlined />,
    label: '规范说明',
    key: '/app/home',
  },
  {
    icon: <ApiOutlined />,
    label: '代收接口',
    key: '/app/payin',
    children:[
      {
        label: '代收提交',
        key: '/app/payin/submit',
      },
      {
        label: '代收查询',
        key: '/app/payin/query',
      },
      {
        label: '代收通知',
        key: '/app/payin/notify',
      },
    ]
  },
  {
    icon: <ApiOutlined />,
    label: '代付接口',
    key: '/app/payout',
    children:[
      {
        label: '代付提交',
        key: '/app/payout/submit',
      },
      {
        label: '代付查询',
        key: '/app/payout/query',
      },
      {
        label: '代付通知',
        key: '/app/payout/notify',
      },
    ]
  },
  {
    icon: <DollarOutlined />,
    label: '商户余额',
    key: '/app/balance/query',
  },
  {
    icon: <BugOutlined />,
    label: '机器人',
    key: '/app/bot/fill',
  },
];


const siderStyle: React.CSSProperties = {
  overflow: 'auto',
  height: '100vh',
  position:"sticky",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  paddingBottom: "50px",
};






const App: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation();

  useEffect(()=>{
    if (localStorage.getItem("token") !== PW){
      navigate("/login")
    }
  },[navigate])
  
  // 菜单栏路由跳转
  const clickMenu = ({key, keyPath, domEvent})=>{
    if (key !== "/app/doc" && key !== "/app/mch"){
      navigate(key)
    }
  }


  return (
    <div style={{margin:"0px auto", width:"1200px"}}>
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={"200px"} theme={"light"} style={siderStyle}>
        <div style={{textAlign:"left", paddingLeft:"56px", borderBottom:"1px solid #ebebeb", height:"50px", lineHeight:"50px"}}>
          <h3>Welcome</h3>
        </div>
        <Menu 
          defaultSelectedKeys={['/app/home']} 
          defaultOpenKeys={['/app/payin','/app/payout',]}
          selectedKeys={[location.pathname]}
          mode="inline" 
          items={items} 
          onClick={clickMenu} 
          style={{textAlign:"left", borderInlineEnd:"none"}}
        />
      </Sider>
      <Layout>
        <Content style={{borderLeft:"1px solid #ccc", borderRight:"1px solid #ccc"}}>
            <Outlet/>
        </Content>
      </Layout>
    </Layout>
    </div>
  );
};

export default App;